import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux';

export enum EPrintActionTypes {
  SetOption = 'PRINT :: SET_OPTION',
  OpenModal = 'PRINT :: OPEN_MODAL',
  CloseModal = 'PRINT :: CLOSE_MODAL',
  PrintHide = 'PRINT :: HIDE',
  PrintRestore = 'PRINT :: RESTORE',
}

export interface IPrintSetOptionsActionPayload {
  optionName: string;
  value: boolean;
}

export type TPrintActions =
  | ITypedReduxAction<EPrintActionTypes.SetOption, IPrintSetOptionsActionPayload>
  | ITypedReduxAction<EPrintActionTypes.OpenModal, void>
  | ITypedReduxAction<EPrintActionTypes.CloseModal, void>
  | IPrintHide
  | IPrintRestore;

export const setOption: (payload: IPrintSetOptionsActionPayload) => TPrintActions = actionGenerator<
  EPrintActionTypes.SetOption,
  IPrintSetOptionsActionPayload
>(EPrintActionTypes.SetOption);

export const openModal: () => TPrintActions = actionGenerator<EPrintActionTypes.OpenModal>(EPrintActionTypes.OpenModal);

export const closeModal: () => TPrintActions = actionGenerator<EPrintActionTypes.CloseModal>(
  EPrintActionTypes.CloseModal,
);

export interface IPrintHide {
  type: EPrintActionTypes.PrintHide;
  entityId: number;
}

export interface IPrintRestore {
  type: EPrintActionTypes.PrintRestore;
  entityId: number;
}

export function printHide(entityId: number): IPrintHide {
  return {
    type: EPrintActionTypes.PrintHide,
    entityId,
  };
}

export function printRestore(entityId: number): IPrintRestore {
  return {
    type: EPrintActionTypes.PrintRestore,
    entityId,
  };
}
